import { objectsAtPoint } from 'Shared/posters/canvas/hitTest'
import type { SelectionContext } from 'Shared/posters/canvas/selection'
import type { ImplRegistry } from 'Shared/posters/canvas/interactions/ObjectImpl'
import type { Position } from 'Shared/posters/types'

// Alt-click cycles the selection down through everything under the cursor, then the canvas
// background (nothing selected), then wraps back to the top.
//
// This is the *only* click that moves the selection onto something already covered by the current
// selection: a plain click drags what is selected rather than picking whatever is painted on top or
// drilling into a child, so Alt-click is how a container's children, and an object underneath
// another, are reached at all.
//
// Purely positional, so it behaves the same whichever element the click physically landed on: the
// object's own <g>, or the intercept rect of whatever is already selected.
//
// The result is pinned (see SelectionContext.pinned) so the click that follows reaches what the
// cycle landed on instead of the object painted over it. selectPinned() rather than selectAt():
// cycling must not prime a follow-up click as a double-click.
export function cycleSelectionAt(client: Position, svg: SVGSVGElement | null, selCtx: SelectionContext, impls: ImplRegistry): void
{
	if (!svg)
		return

	const stack = objectsAtPoint(client, svg, impls)
	const cur   = selCtx.selected()

	// -1 covers both "nothing selected" and "the selection isn't under the cursor", so the cycle
	// starts at the top; running off the bottom (or an empty stack — bare canvas) gives undefined,
	// which is the background stop.
	const at   = cur ? stack.indexOf(cur) : -1
	const next = stack[at + 1]

	console.log('[cycle] stack', stack, 'current', cur, 'at', at, '→', next ?? '(background)')

	if (next)
		selCtx.selectPinned(next)
	else
		selCtx.deselect()
}
